import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { strings } from '../../constants';
import ArrowBackIcon from '../CustomSVGIcons/ArrowBackButton';

interface DetailProps {
    handleDetails?: () => void;
    sx?: SxProps<Theme>;
}

const EsBackButton = ({ handleDetails, sx }: DetailProps) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            sx={{ gap: '10px', cursor: 'pointer' }}
            onClick={handleDetails}>
            <ArrowBackIcon fill={theme[themeStyle].true_white} />
            <Typography
                sx={{
                    color: theme[themeStyle].true_white,
                    fontSize: 14,
                    fontWeight: '500',
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    ...sx,
                }}>
                {strings.back}
            </Typography>
        </Box>
    );
};

export { EsBackButton };
